import { Urls } from '../../common/urlRouting';
import { StringConstants } from './constants'

export const createTodoUrl = function (type, wkId, actId, typeId, customFields, wkNumber) {
  var customerTag = "";
  customFields.map((data) => {
    if (data.FieldKey == 'customername_lastname_string')
      return customerTag = data.Value;
  })
  return Urls.CREATE_TODO + "?ret=getclmdetail&cid=" + wkId + "&actId=" + actId + "&type=" + type + "&ref=" + typeId + "&cno=" + wkNumber + "&uln=" + customerTag;
}

export const createDiaryUrl = function (todoId, type, typeId) {
  if (type === StringConstants.workkard)
    return Urls.DIARY_TITLE + "?id=" + todoId + "&cid=" + typeId;
  else
    return Urls.DIARY_TITLE + "?id=" + todoId + "&actId=" + typeId;
}